// extracted by mini-css-extract-plugin
export default {"comment":"formik-rating-field-module--comment--95d5e","ratingDescription":"formik-rating-field-module--ratingDescription--ed024","rating":"formik-rating-field-module--rating--987bc"};